module.exports = __webpack_public_path__ + "static/img/360.0fb09ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/360.png
// module id = 52oL
// module chunks = 3